<template>
  <div class="ratio-box">
    <h5>{{$t('stats.rate')}}</h5>
    <div class="d-flex justify-content-between mt-3">
      <canvas ref="canvas" class="pie-chart"></canvas>

      <div class="pie-info">
        <p class="c-del">Delivery {{percentage.delivery}}%</p>
        <p class="c-pre">Preorder {{percentage.preorder}}%</p>
        <p class="c-ins">Inside {{percentage.inside}}%</p>
      </div>
    </div>

    <div class="orders-amount">
      <p class="c-del">Delivery - {{ counts.delivery }} {{$t('stats.orders')}}</p>
      <p class="c-pre">Preorder - {{ counts.preorder }} {{$t('stats.orders')}}</p>
      <p class="c-ins">Inside - {{ counts.inside }} {{$t('stats.orders')}}</p>
    </div>
  </div>
</template>

<script>
import { Pie } from "vue-chartjs";
export default {
  extends: Pie,
  props: {
    counts: Object
  },
  methods: {},
  mounted() {
    this.renderChart({
      labels: ['Delivery', 'Preorder', 'Inside'],
      datasets: [
        {
          data: [
            this.counts.delivery,
            this.counts.preorder,
            this.counts.inside
          ],
          fontSize: 0,
          borderWidth: 0,
          backgroundColor: ["#CBD9E6", "#FFD2A8", "#129B81"]
        }
      ]
    });
  },
  computed: {
    percentage() {
      //100 - total
      //x - count

      //x = 100 * count / total

      const total = this.counts.inside + this.counts.preorder + this.counts.delivery;
      return {
        inside: Math.round(100 * this.counts.inside / total),
        preorder: Math.round(100 * this.counts.preorder / total),
        delivery: Math.round(100 * this.counts.delivery / total),
      }
    }
  }
};
</script>

<style scoped>
h5 {
  font-size: 2.2vh;
  margin-bottom: 0;
}

.c-ins {
  color: #129b81;
}

.c-pre {
  color: #ffd2a8;
}

.c-del {
  color: #cbd9e6;
}

p {
  padding-top: 0.6vh;
  margin: 0;
  line-height: initial;
  font-size: 1.8vh;
}

.orders-amount {
  margin-top: 2.2vh;
}

.ratio-box {
  width: 33vh;
  color: #ededed;
  padding: 3vh;
  border-radius: 1vh;
  background: #1d1d1b;
}
.pie-chart {
  margin-left: -5vh;
  height: 11vh !important;
  width: 21.5vh !important;
}

.pie-info {
  position: absolute;
  margin-left: 14vh;
}

</style>